import { render, staticRenderFns } from "./Reject.vue?vue&type=template&id=16e5cafa"
import script from "./Reject.vue?vue&type=script&lang=js"
export * from "./Reject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports